"use strict";
var lib_core = require("lib-core");
if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var AbstractPosAngleInteractionModel = require("./abstractPosAngleInteractionModel.js");
var cio_config = require("cio-config");

var AbstractPosAngleScaleInteractionModel = function (data, editorModel) {
    var self = this;
    AbstractPosAngleInteractionModel.call(this, data, editorModel);

    this.showXscale = this.shadow("showXscale",
        function () {
            return self.data.scaleX();
        },
        function (value) {
            return self.data.scaleX(value);
        },
        [this.data.angle]
    );
    this.showYscale = this.shadow("showYscale",
        function () {
            return self.data.scaleY();
        },
        function (value) {
            return self.data.scaleY(value);
        },
        [this.data.angle]
    );

};
lib_core.inherit(AbstractPosAngleScaleInteractionModel, AbstractPosAngleInteractionModel);

module.exports = AbstractPosAngleScaleInteractionModel;

AbstractPosAngleScaleInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.push(
        {
            label      : 'Scale X',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showXscale,
            datatype   : cio_config.types.float
        });
    inspectorElements.input_elements.push(
        {
            label      : 'Scale Y',
            type       : ui_extensions.InspectorInputType.TEXT,
            datamember : this.showYscale,
            datatype   : cio_config.types.float
        }
    );

    return inspectorElements;
};
